import React from 'react';

import { Flex, Box } from '@lucidhq/lucidium';

import { useCampaignManager } from '~/components/CampaignManager/CampaignManagerProvider';
import { useFetchForcedExposureCreatives } from '~/components/Shared/hooks/useFetchForcedExposureCreatives';

import { Colors, ReviewLayout } from '../../Misc/ReviewLayout';
import { CreativeDiscrepancy } from './CreativeDiscrepancy';
import { NoCreatives } from './NoCreatives';

export const CreativesBlock = () => {
  const { managedCampaign, goToStep, steps, can } = useCampaignManager();
  const { data } = useFetchForcedExposureCreatives(
    managedCampaign?.details.campaign_id
  );

  const creativesNumber =
    managedCampaign?.details.draft_settings.forced_exposure?.creatives_number;

  if (!data?.items || data.items.length === 0)
    return (
      <ReviewLayout.Content color={Colors.BLUE}>
        <NoCreatives />
      </ReviewLayout.Content>
    );

  if (data.items.length !== creativesNumber)
    return (
      <ReviewLayout.Content color={Colors.BLUE}>
        <CreativeDiscrepancy
          amount={creativesNumber}
          uploaded={data?.items.length}
        />
      </ReviewLayout.Content>
    );

  return (
    <ReviewLayout.Content color={Colors.BLUE}>
      {(can.edit || can.limitedEdit) && (
        <ReviewLayout.Edit onClick={() => goToStep(steps.MEDIA_TRACKING.id)} />
      )}
      <ReviewLayout.Item lss={{ paddingTop: '48px' }}>
        <Flex
          data-testid="review-discrepancy-block"
          lss={{ flexDirection: 'column', gap: '8px' }}
        >
          {data.items.map(item => (
            <Box
              key={item.id}
              lss={{ width: '100%', padding: '20px 16px', border: 'regular' }}
            >
              {item.display_name}
            </Box>
          ))}
        </Flex>
      </ReviewLayout.Item>
    </ReviewLayout.Content>
  );
};
